import axios from '@/api/requests/axios'

export default {
  getByCityId: (cityId) => axios.get(`/api/admin/v1/delivery-areas/${cityId}`),
  put: (deliveryArea) => axios.put(`/api/admin/v1/delivery-areas`, deliveryArea)
}
